import { getBlokComponentName } from '~/utils/storyblok'

export default {
  props: {
    blok: {
      type: Object,
      required: true
    }
  },
  methods: {
    getBlokComponentName
  }
}
